module.exports = __webpack_public_path__ + "static/media/hall-AG.afbeecb3.svg";